import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useWebRouter } from "~utils/next-router/use-web-router";
import {
	GET_DATASET_ACCESS_METHOD_TYPE,
	GetDatasetByAuthorizedUserQuery,
	GetDatasetByPublicQuery,
} from "~dataset-view/types/__generated/gql/graphql";
import { useGetCurrentDatasetAccessMethod } from "../useGetDatasetAccessMethod";
import { getDatasetByAuthorizedUser } from "./getDatasetByAuthorizedUser";
import { getDatasetByPublic } from "./getDatasetByPublic";

export const getCurrentDatasetQueryKey = (id: string) => [
	"getCurrentDataset",
	id,
];

export const useGetCurrentDataset = (): UseQueryResult<
	| GetDatasetByAuthorizedUserQuery["getDatasetByAuthorizedUser"]
	| GetDatasetByPublicQuery["getDatasetByPublic"]
> => {
	const { _query } = useWebRouter();

	const { data } = useGetCurrentDatasetAccessMethod();

	return useQuery({
		enabled: !!_query.datasetId && !!data,
		queryKey: getCurrentDatasetQueryKey(_query.datasetId!),
		// @ts-ignore
		queryFn: () => {
			switch (data!.type) {
				case GET_DATASET_ACCESS_METHOD_TYPE.AUTHORIZED_USER:
					return getDatasetByAuthorizedUser({
						id: _query.datasetId!,
					});
				case GET_DATASET_ACCESS_METHOD_TYPE.PUBLIC:
					return getDatasetByPublic({
						id: _query.datasetId!,
					});
			}
		},
	});
};

export const useGetDatasetById = (
	id?: string,
): UseQueryResult<
	GetDatasetByAuthorizedUserQuery["getDatasetByAuthorizedUser"]
> => {
	return useQuery({
		enabled: !!id,
		queryKey: ["getDatasetById", id],
		queryFn: () =>
			getDatasetByAuthorizedUser({
				id: id!,
			}),
	});
};
